// removed by extract-text-webpack-plugin
module.exports = {"theme":"#44c9c1"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/element-variables.scss
// module id = +hAf
// module chunks = 78